import { render, staticRenderFns } from "./IconBonus.vue?vue&type=template&id=28271e62&"
import script from "./IconBonus.vue?vue&type=script&lang=js&"
export * from "./IconBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports